import { fg } from '@atlaskit/platform-feature-flags/fg';

import { loadMoreConversationChannelsData } from './loadMoreConversationChannelsData';
import type { ChatStoreAction } from './types';

export const setConversationListMounted =
	(isConversationListMounted: boolean): ChatStoreAction =>
	({ setState, getState, dispatch }) => {
		const { conversationPagination, isConversationsInitialized } = getState();
		setState({
			conversationPagination: {
				...conversationPagination,
				isConversationListMounted,
			},
		});

		if (
			fg('rovo_chat_conversation_search_pagination') &&
			isConversationListMounted &&
			!conversationPagination.isConversationListMounted &&
			isConversationsInitialized
		) {
			void dispatch(loadMoreConversationChannelsData());
		}
	};
